// Comprehensive 1000+ Templates for GYNOVATE AI/SI
// Organized by clinical categories

export const ALL_TEMPLATES = {
  // ==========================================
  // EMERGENCY & CRITICAL CARE (100+ templates)
  // ==========================================
  emergency: [
    // Obstetric Emergencies
    'Emergency: Postpartum hemorrhage with shock - immediate management',
    'Emergency: Eclampsia with active seizures - MgSO4 protocol',
    'Emergency: Ruptured ectopic pregnancy - surgical decision',
    'Emergency: Severe preeclampsia at 28 weeks - stabilization',
    'Emergency: Cord prolapse during labor - immediate steps',
    'Emergency: Placental abruption with fetal distress',
    'Emergency: Shoulder dystocia - McRoberts maneuver',
    'Emergency: Amniotic fluid embolism - recognition and management',
    'Emergency: Uterine inversion post delivery',
    'Emergency: DIC in obstetric patient - transfusion protocol',
    'Emergency: Placenta accreta spectrum - delivery planning',
    'Emergency: Uterine rupture in labor - signs and management',
    'Emergency: Maternal cardiac arrest - perimortem cesarean',
    'Emergency: HELLP syndrome acute management',
    'Emergency: Septic abortion with sepsis',
    'Emergency: Pulmonary embolism in pregnancy',
    'Emergency: Acute fatty liver of pregnancy',
    'Emergency: Cervical incompetence with bulging membranes',
    'Emergency: Preterm labor at 24 weeks with PPROM',
    'Emergency: Severe hyperemesis with metabolic derangement',
    'Emergency: Diabetic ketoacidosis in pregnancy',
    'Emergency: Thyroid storm in pregnancy',
    'Emergency: Sickle cell crisis in pregnancy',
    'Emergency: Status epilepticus in pregnant patient',
    'Emergency: Acute asthma exacerbation in pregnancy',
    // Gynecologic Emergencies
    'Emergency: Ruptured ovarian cyst with hemoperitoneum',
    'Emergency: Ovarian torsion - diagnosis and surgery timing',
    'Emergency: Tubo-ovarian abscess with sepsis',
    'Emergency: Incomplete abortion with heavy bleeding',
    'Emergency: Perforated uterus during D&C',
    'Emergency: Post-hysterectomy vault hematoma rupture',
    'Emergency: Necrotizing fasciitis post cesarean',
    'Emergency: Anaphylaxis to oxytocin in labor',
    'Emergency: Hemorrhage from cervical cancer',
    'Emergency: Acute urinary retention post gynec surgery',
    // Neonatal Emergencies
    'Emergency: Neonatal resuscitation - NRP protocol',
    'Emergency: Meconium aspiration at delivery',
    'Emergency: Premature baby respiratory distress',
    'Emergency: Neonatal hypoglycemia management',
    'Emergency: Birth asphyxia - therapeutic hypothermia criteria',
    // Anesthesia Emergencies
    'Emergency: High spinal block in cesarean',
    'Emergency: Local anesthetic toxicity - lipid rescue',
    'Emergency: Failed intubation in obstetric patient',
    'Emergency: Aspiration pneumonitis during anesthesia',
    'Emergency: Malignant hyperthermia in labor',
    // Code Situations
    'Emergency: Code Blue in labor ward - team roles',
    'Emergency: Massive transfusion protocol activation',
    'Emergency: Emergency hysterectomy decision making',
    'Emergency: Maternal collapse algorithm',
    'Emergency: Obstetric early warning score interpretation',
  ],

  // ==========================================
  // OPD CONSULTATION (100+ templates)
  // ==========================================
  opd: [
    // Common Gynec Conditions
    'OPD: PCOS with irregular cycles and hirsutism - complete workup',
    'OPD: Heavy menstrual bleeding - investigations and management',
    'OPD: Post-menopausal bleeding - red flag evaluation',
    'OPD: Chronic pelvic pain - differential diagnosis',
    'OPD: Recurrent vaginal discharge - diagnosis flowchart',
    'OPD: Fibroid uterus - management options',
    'OPD: Endometriosis with dysmenorrhea',
    'OPD: Adenomyosis with heavy periods',
    'OPD: Ovarian cyst - benign vs concerning features',
    'OPD: Bartholin cyst management',
    'OPD: Vulvar itching - causes and treatment',
    'OPD: Cervical ectopy with discharge',
    'OPD: Pelvic organ prolapse staging',
    'OPD: Stress urinary incontinence workup',
    'OPD: Overactive bladder syndrome',
    'OPD: Interstitial cystitis evaluation',
    'OPD: Vulvodynia management approach',
    'OPD: Lichen sclerosus diagnosis and treatment',
    'OPD: Genital warts HPV management',
    'OPD: Herpes simplex genital outbreak',
    'OPD: Pelvic inflammatory disease treatment',
    'OPD: Recurrent UTI in women',
    'OPD: Sexual dysfunction in women',
    'OPD: Vaginismus treatment approach',
    'OPD: Dyspareunia evaluation',
    // Adolescent Gynecology
    'OPD: Adolescent with primary amenorrhea',
    'OPD: Secondary amenorrhea workup',
    'OPD: Adolescent PCOS - age-appropriate approach',
    'OPD: Precocious puberty evaluation',
    'OPD: Delayed puberty in girls',
    'OPD: Adolescent with severe dysmenorrhea',
    'OPD: Imperforate hymen presentation',
    'OPD: Vaginal septum causing difficulty',
    // Menopause
    'OPD: Perimenopausal symptoms management',
    'OPD: Menopausal hot flashes treatment',
    'OPD: Vaginal atrophy post menopause',
    'OPD: Osteoporosis prevention in menopause',
    'OPD: HRT candidacy assessment',
    'OPD: Non-hormonal alternatives for menopause',
    'OPD: Premature ovarian insufficiency',
    // Contraception
    'OPD: Contraception counseling - all methods',
    'OPD: IUCD insertion candidacy',
    'OPD: OCP prescription with contraindications check',
    'OPD: Emergency contraception options',
    'OPD: Post-partum contraception timing',
    'OPD: Contraception for lactating mother',
    'OPD: Permanent sterilization counseling',
    // Screening
    'OPD: Cervical cancer screening guidelines',
    'OPD: Abnormal Pap smear management',
    'OPD: HPV positive with normal cytology',
    'OPD: Breast lump evaluation protocol',
    'OPD: Annual gynec checkup components',
    // Pre-operative Assessment
    'OPD: Pre-op assessment for hysterectomy',
    'OPD: Pre-op workup for laparoscopic surgery',
    'OPD: Cardiac clearance for gynec surgery',
    'OPD: Anemia correction before surgery',
    'OPD: Pre-op optimization for diabetic patient',
  ],

  // ==========================================
  // ANTENATAL CARE (100+ templates)
  // ==========================================
  antenatal: [
    // Routine Care
    'ANC: First trimester booking visit checklist',
    'ANC: 12 weeks NT scan counseling',
    'ANC: Second trimester routine checkup',
    'ANC: 20 weeks anomaly scan preparation',
    'ANC: Third trimester growth monitoring',
    'ANC: 36 weeks Group B strep screening',
    'ANC: Term pregnancy - delivery planning',
    'ANC: Post-dates pregnancy management',
    // High Risk Pregnancy
    'ANC: Gestational diabetes management plan',
    'ANC: Pregnancy induced hypertension monitoring',
    'ANC: Pre-existing hypertension in pregnancy',
    'ANC: Chronic kidney disease in pregnancy',
    'ANC: Heart disease in pregnancy - risk stratification',
    'ANC: Epilepsy in pregnancy management',
    'ANC: Thyroid disorder in pregnancy',
    'ANC: Anemia in pregnancy - iron protocol',
    'ANC: Thrombophilia in pregnancy',
    'ANC: Antiphospholipid syndrome management',
    'ANC: SLE flare in pregnancy',
    'ANC: Pregnancy after bariatric surgery',
    'ANC: Obesity in pregnancy - risks and monitoring',
    // Multiple Pregnancy
    'ANC: Twin pregnancy - dichorionic monitoring',
    'ANC: Monochorionic twins - TTTS screening',
    'ANC: Triplet pregnancy management',
    'ANC: Selective fetal reduction counseling',
    // Fetal Conditions
    'ANC: IUGR - monitoring protocol',
    'ANC: Large for gestational age baby',
    'ANC: Oligohydramnios management',
    'ANC: Polyhydramnios evaluation',
    'ANC: Placenta previa follow up',
    'ANC: Low-lying placenta - repeat scan timing',
    'ANC: Velamentous cord insertion',
    'ANC: Single umbilical artery',
    'ANC: Short cervix - cerclage discussion',
    'ANC: Fetal arrhythmia evaluation',
    'ANC: Hydrops fetalis workup',
    'ANC: Fetal anomaly detected - counseling',
    // Previous Complications
    'ANC: Previous cesarean - VBAC candidacy',
    'ANC: History of preterm birth - prevention',
    'ANC: Previous preeclampsia - aspirin prophylaxis',
    'ANC: Recurrent pregnancy loss - current pregnancy',
    'ANC: Previous stillbirth - enhanced monitoring',
    'ANC: Previous shoulder dystocia - planning',
    'ANC: Previous PPH - delivery planning',
    'ANC: Grand multipara - special considerations',
    // Special Situations
    'ANC: Advanced maternal age pregnancy',
    'ANC: Teen pregnancy - special needs',
    'ANC: IVF pregnancy monitoring',
    'ANC: Pregnancy after myomectomy',
    'ANC: Pregnancy with cervical cerclage',
    'ANC: COVID in pregnancy management',
    'ANC: Rh negative pregnancy - anti-D timing',
    'ANC: Alloimmunization management',
    // Labor Planning
    'ANC: Birth plan discussion',
    'ANC: Induction of labor counseling',
    'ANC: Elective cesarean discussion',
    'ANC: External cephalic version counseling',
    'ANC: Breech presentation options',
  ],

  // ==========================================
  // INFERTILITY (100+ templates)
  // ==========================================
  infertility: [
    // Initial Workup
    'Infertility: Primary infertility 2 years - initial assessment',
    'Infertility: Secondary infertility workup',
    'Infertility: Day 2/3 hormonal profile interpretation',
    'Infertility: AMH interpretation by age',
    'Infertility: AFC assessment and prognosis',
    'Infertility: HSG findings interpretation',
    'Infertility: Diagnostic laparoscopy indications',
    'Infertility: Hysteroscopy for uterine cavity',
    'Infertility: Complete semen analysis interpretation',
    'Infertility: Sperm DNA fragmentation testing',
    // Female Factor
    'Infertility: PCOS with anovulation - ovulation induction',
    'Infertility: Tubal factor - management options',
    'Infertility: Blocked tubes - IVF vs surgery',
    'Infertility: Hydrosalpinx before IVF',
    'Infertility: Endometriosis related infertility',
    'Infertility: Adenomyosis impact on fertility',
    'Infertility: Fibroids and fertility - when to operate',
    'Infertility: Uterine septum correction',
    'Infertility: Asherman syndrome treatment',
    'Infertility: Thin endometrium management',
    'Infertility: Premature ovarian insufficiency',
    'Infertility: Diminished ovarian reserve - options',
    'Infertility: Poor ovarian response - protocols',
    'Infertility: High responder - OHSS prevention',
    'Infertility: Hyperprolactinemia treatment',
    'Infertility: Thyroid optimization for fertility',
    // Male Factor
    'Infertility: Oligospermia management',
    'Infertility: Azoospermia - obstructive vs non-obstructive',
    'Infertility: TESA/TESE indications',
    'Infertility: Varicocele and fertility',
    'Infertility: Male lifestyle factors affecting fertility',
    'Infertility: Donor sperm counseling',
    // Treatment Options
    'Infertility: Timed intercourse protocol',
    'Infertility: Ovulation induction with Letrozole',
    'Infertility: Clomiphene citrate protocol',
    'Infertility: Gonadotropin stimulation for OI',
    'Infertility: IUI procedure and timing',
    'Infertility: IUI vs IVF - decision making',
    'Infertility: IVF long protocol explanation',
    'Infertility: IVF antagonist protocol',
    'Infertility: Mini IVF indications',
    'Infertility: Natural cycle IVF',
    'Infertility: ICSI indications',
    'Infertility: Blastocyst vs Day 3 transfer',
    'Infertility: Frozen embryo transfer protocol',
    'Infertility: PGT-A counseling',
    'Infertility: Donor egg IVF process',
    'Infertility: Surrogacy - medical aspects',
    // Special Situations
    'Infertility: Recurrent implantation failure',
    'Infertility: Recurrent pregnancy loss workup',
    'Infertility: Unexplained infertility - approach',
    'Infertility: Age 40+ - realistic counseling',
    'Infertility: Single woman fertility options',
    'Infertility: Same-sex couple fertility planning',
    'Infertility: Fertility preservation before cancer',
    'Infertility: Egg freezing - social reasons',
    'Infertility: Post cancer fertility restoration',
  ],

  // ==========================================
  // LABOR & DELIVERY (80+ templates)
  // ==========================================
  labor: [
    // Normal Labor
    'Labor: Admission in early labor - assessment',
    'Labor: Active labor management',
    'Labor: Partograph interpretation',
    'Labor: Second stage management',
    'Labor: Third stage active management',
    'Labor: Episiotomy - indications and technique',
    'Labor: Perineal tear classification',
    'Labor: Fourth degree tear repair principles',
    'Labor: Normal delivery documentation',
    // Labor Abnormalities
    'Labor: Prolonged latent phase management',
    'Labor: Arrest of labor - decision making',
    'Labor: Prolonged second stage - options',
    'Labor: Cephalopelvic disproportion diagnosis',
    'Labor: Malposition - OP position management',
    'Labor: Face presentation management',
    'Labor: Brow presentation delivery',
    'Labor: Breech vaginal delivery',
    'Labor: Compound presentation',
    // Induction
    'Labor: Induction of labor - Bishop score based',
    'Labor: Cervical ripening methods',
    'Labor: Foley catheter induction',
    'Labor: Prostaglandin induction protocol',
    'Labor: Oxytocin augmentation protocol',
    'Labor: Failed induction management',
    // Operative Delivery
    'Labor: Vacuum extraction - indications',
    'Labor: Forceps delivery - prerequisites',
    'Labor: Trial of instrumental vs cesarean',
    'Labor: Cesarean section - types and indications',
    'Labor: Emergency cesarean classification',
    'Labor: Classical cesarean indications',
    // VBAC
    'Labor: VBAC selection criteria',
    'Labor: TOLAC monitoring protocol',
    'Labor: VBAC success prediction',
    // Fetal Monitoring
    'Labor: CTG interpretation basics',
    'Labor: Non-reassuring CTG - management',
    'Labor: Fetal scalp blood sampling',
    'Labor: Cord blood gas interpretation',
    // Pain Management
    'Labor: Non-pharmacological pain relief',
    'Labor: Epidural analgesia counseling',
    'Labor: Combined spinal-epidural',
    'Labor: Walking epidural protocol',
    // Complications
    'Labor: Cord prolapse immediate management',
    'Labor: Shoulder dystocia - HELPERR mnemonic',
    'Labor: PPH prevention and management',
    'Labor: Retained placenta management',
    'Labor: Uterine inversion correction',
    'Labor: Amniotic fluid embolism',
  ],

  // ==========================================
  // SURGERY - LAPAROSCOPY (60+ templates)
  // ==========================================
  laparoscopy: [
    // Diagnostic
    'Laparoscopy: Diagnostic for chronic pelvic pain',
    'Laparoscopy: Diagnostic for infertility',
    'Laparoscopy: Staging laparoscopy for cancer',
    // Ovarian Surgery
    'Laparoscopy: Ovarian cystectomy technique',
    'Laparoscopy: Ovarian drilling for PCOS',
    'Laparoscopy: Oophorectomy - indications',
    'Laparoscopy: Ovarian detorsion',
    'Laparoscopy: Paraovarian cyst excision',
    // Tubal Surgery
    'Laparoscopy: Salpingectomy for ectopic',
    'Laparoscopy: Salpingostomy for ectopic',
    'Laparoscopy: Bilateral salpingectomy before IVF',
    'Laparoscopy: Tubal ligation techniques',
    'Laparoscopy: Tubal recannulation',
    'Laparoscopy: Fimbrioplasty technique',
    // Hysterectomy
    'Laparoscopy: TLH - total laparoscopic hysterectomy',
    'Laparoscopy: LAVH technique',
    'Laparoscopy: TLH for large uterus',
    'Laparoscopy: TLH with BSO',
    'Laparoscopy: Supracervical hysterectomy',
    // Myomectomy
    'Laparoscopy: Myomectomy - patient selection',
    'Laparoscopy: Myomectomy for subserous fibroid',
    'Laparoscopy: Myomectomy for intramural fibroid',
    'Laparoscopy: Power morcellation controversy',
    // Endometriosis
    'Laparoscopy: Endometriosis staging and excision',
    'Laparoscopy: Deep infiltrating endometriosis',
    'Laparoscopy: Endometrioma excision',
    'Laparoscopy: Rectovaginal endometriosis',
    'Laparoscopy: Bladder endometriosis excision',
    // Adhesiolysis
    'Laparoscopy: Pelvic adhesiolysis technique',
    'Laparoscopy: Bowel adhesions - safe dissection',
    // Urogynaecology
    'Laparoscopy: Burch colposuspension',
    'Laparoscopy: Sacrocolpopexy technique',
    'Laparoscopy: Paravaginal repair',
    // Cancer
    'Laparoscopy: Pelvic lymphadenectomy',
    'Laparoscopy: Para-aortic lymph node sampling',
    'Laparoscopy: Radical hysterectomy',
    // Complications
    'Laparoscopy: Port site complications',
    'Laparoscopy: Bowel injury recognition',
    'Laparoscopy: Ureteric injury prevention',
    'Laparoscopy: Vascular injury management',
    'Laparoscopy: Conversion to laparotomy - when',
  ],

  // ==========================================
  // SURGERY - HYSTEROSCOPY (40+ templates)
  // ==========================================
  hysteroscopy: [
    // Diagnostic
    'Hysteroscopy: Diagnostic for AUB',
    'Hysteroscopy: Office hysteroscopy technique',
    'Hysteroscopy: Infertility evaluation',
    // Operative Procedures
    'Hysteroscopy: Polypectomy technique',
    'Hysteroscopy: Submucous myomectomy - G0-G2',
    'Hysteroscopy: Myomectomy for large fibroid',
    'Hysteroscopy: Endometrial ablation',
    'Hysteroscopy: Septum resection',
    'Hysteroscopy: Asherman syndrome treatment',
    'Hysteroscopy: Adhesiolysis technique',
    'Hysteroscopy: Foreign body removal',
    'Hysteroscopy: Retained products removal',
    'Hysteroscopy: Tubal cannulation',
    'Hysteroscopy: Essure removal',
    // Complications
    'Hysteroscopy: Fluid overload management',
    'Hysteroscopy: Uterine perforation recognition',
    'Hysteroscopy: Thermal injury prevention',
    'Hysteroscopy: Cervical laceration repair',
  ],

  // ==========================================
  // SURGERY - OPEN PROCEDURES (40+ templates)
  // ==========================================
  openSurgery: [
    // Hysterectomy
    'Surgery: Abdominal hysterectomy technique',
    'Surgery: Vaginal hysterectomy - patient selection',
    'Surgery: Vaginal hysterectomy technique',
    'Surgery: Subtotal hysterectomy indications',
    'Surgery: Hysterectomy for giant fibroid',
    // Myomectomy
    'Surgery: Abdominal myomectomy technique',
    'Surgery: Myomectomy for multiple fibroids',
    'Surgery: Myomectomy hemostasis techniques',
    // Cancer Surgery
    'Surgery: Staging laparotomy for ovarian cancer',
    'Surgery: Debulking surgery principles',
    'Surgery: Radical hysterectomy open technique',
    'Surgery: Pelvic exenteration indications',
    // Other Procedures
    'Surgery: Cesarean section - transverse incision',
    'Surgery: Classical cesarean technique',
    'Surgery: Cesarean hysterectomy',
    'Surgery: Ectopic pregnancy laparotomy',
    'Surgery: Ovarian cystectomy - open',
    'Surgery: Tubo-ovarian abscess drainage',
    // Pelvic Floor
    'Surgery: Anterior colporrhaphy',
    'Surgery: Posterior colporrhaphy',
    'Surgery: Manchester repair',
    'Surgery: Sacrospinous fixation',
    'Surgery: Colpocleisis for elderly',
    // Complications
    'Surgery: Bladder injury repair',
    'Surgery: Ureteric injury management',
    'Surgery: Bowel injury in gynec surgery',
    'Surgery: Wound dehiscence management',
  ],

  // ==========================================
  // POST-OPERATIVE CARE (50+ templates)
  // ==========================================
  postOp: [
    // Immediate Post-op
    'Post-op: Immediate recovery room care',
    'Post-op: Day 0 cesarean monitoring',
    'Post-op: Day 0 hysterectomy care',
    'Post-op: Pain management protocol',
    'Post-op: Fluid management post surgery',
    'Post-op: DVT prophylaxis protocol',
    'Post-op: Early mobilization importance',
    // Daily Reviews
    'Post-op: Day 1 cesarean review',
    'Post-op: Day 1 hysterectomy assessment',
    'Post-op: Day 2 laparoscopy discharge',
    'Post-op: Day 3 post cesarean discharge',
    // Complications
    'Post-op: Fever workup algorithm',
    'Post-op: Wound infection management',
    'Post-op: Paralytic ileus management',
    'Post-op: Urinary retention management',
    'Post-op: Vault hematoma recognition',
    'Post-op: Secondary hemorrhage management',
    'Post-op: Burst abdomen emergency',
    'Post-op: Pulmonary complications',
    'Post-op: Anastomotic leak signs',
    // Discharge Planning
    'Post-op: Discharge instructions cesarean',
    'Post-op: Discharge instructions hysterectomy',
    'Post-op: Wound care instructions',
    'Post-op: Activity restrictions post surgery',
    'Post-op: When to seek emergency care',
    'Post-op: Follow up schedule',
  ],

  // ==========================================
  // PATIENT COUNSELING (80+ templates)
  // ==========================================
  counseling: [
    // Diagnosis Counseling
    'Counseling: PCOS diagnosis explanation',
    'Counseling: Endometriosis diagnosis',
    'Counseling: Fibroid diagnosis options',
    'Counseling: Ovarian cyst - benign reassurance',
    'Counseling: Abnormal Pap smear explanation',
    'Counseling: HPV positive result discussion',
    'Counseling: Cervical dysplasia management',
    'Counseling: Cancer diagnosis breaking news',
    'Counseling: Infertility diagnosis empathetic',
    'Counseling: Recurrent miscarriage support',
    'Counseling: Premature menopause diagnosis',
    'Counseling: Genetic abnormality in fetus',
    // Treatment Counseling
    'Counseling: Hysterectomy options discussion',
    'Counseling: Myomectomy vs hysterectomy',
    'Counseling: Medical vs surgical management',
    'Counseling: Laparoscopy vs open surgery',
    'Counseling: IVF process explanation',
    'Counseling: Egg donation recipient',
    'Counseling: Surrogacy process medical',
    'Counseling: Fertility preservation options',
    'Counseling: Chemotherapy effects on fertility',
    // Pregnancy Counseling
    'Counseling: High risk pregnancy discussion',
    'Counseling: Gestational diabetes explanation',
    'Counseling: Preeclampsia warning signs',
    'Counseling: VBAC vs repeat cesarean',
    'Counseling: Preterm labor signs',
    'Counseling: Fetal anomaly detected',
    'Counseling: IUGR explanation to parents',
    'Counseling: Stillbirth support',
    'Counseling: Neonatal death support',
    // Lifestyle Counseling
    'Counseling: Weight management for PCOS',
    'Counseling: Exercise in pregnancy',
    'Counseling: Smoking cessation pregnancy',
    'Counseling: Alcohol in pregnancy',
    'Counseling: Diet for gestational diabetes',
    'Counseling: Pre-conception planning',
    // Sensitive Topics
    'Counseling: Sexual dysfunction',
    'Counseling: Domestic violence screening',
    'Counseling: Teen pregnancy support',
    'Counseling: Unplanned pregnancy options',
    'Counseling: Termination of pregnancy',
    'Counseling: Post-abortion support',
    'Counseling: Menopause and sexuality',
    'Counseling: Contraception after loss',
  ],

  // ==========================================
  // DOCUMENTATION - CONSENT (50+ templates)
  // ==========================================
  consent: [
    // Surgical Consents
    'Consent: Cesarean section comprehensive',
    'Consent: Emergency cesarean brief',
    'Consent: Hysterectomy - TLH detailed',
    'Consent: Vaginal hysterectomy',
    'Consent: Laparoscopic myomectomy',
    'Consent: Abdominal myomectomy',
    'Consent: Diagnostic laparoscopy',
    'Consent: Operative laparoscopy',
    'Consent: Hysteroscopy diagnostic',
    'Consent: Hysteroscopy operative',
    'Consent: D&C for incomplete abortion',
    'Consent: Cervical cerclage',
    'Consent: Ectopic surgery - salpingectomy',
    'Consent: Ovarian cystectomy',
    'Consent: Oophorectomy',
    'Consent: Pelvic floor repair',
    'Consent: Tension free vaginal tape',
    'Consent: LEEP/LLETZ procedure',
    'Consent: Cone biopsy',
    // Obstetric Consents
    'Consent: Induction of labor',
    'Consent: Instrumental delivery',
    'Consent: Episiotomy',
    'Consent: Manual removal of placenta',
    'Consent: External cephalic version',
    'Consent: Trial of labor after cesarean',
    // Medical Consents
    'Consent: Blood transfusion detailed',
    'Consent: Anesthesia - epidural',
    'Consent: Anesthesia - spinal',
    'Consent: Anesthesia - general',
    'Consent: IVF/ICSI treatment',
    'Consent: Embryo freezing',
    'Consent: Egg retrieval procedure',
    'Consent: Embryo transfer',
    'Consent: Donor gamete use',
    // Special Consents
    'Consent: High risk procedure',
    'Consent: Refusal of blood transfusion',
    'Consent: Against medical advice discharge',
    'Consent: Surgical consent minor patient',
    'Consent: Emergency without guardian',
    'Consent: Research participation',
    'Consent: Photography/video recording',
  ],

  // ==========================================
  // DOCUMENTATION - DISCHARGE (40+ templates)
  // ==========================================
  discharge: [
    // Post Surgery
    'Discharge: Post cesarean section',
    'Discharge: Post vaginal delivery',
    'Discharge: Post cesarean with complications',
    'Discharge: Post laparoscopic hysterectomy',
    'Discharge: Post vaginal hysterectomy',
    'Discharge: Post abdominal hysterectomy',
    'Discharge: Post laparoscopic myomectomy',
    'Discharge: Post hysteroscopy',
    'Discharge: Post D&C',
    'Discharge: Post ectopic surgery',
    'Discharge: Post ovarian cystectomy',
    'Discharge: Post pelvic floor repair',
    'Discharge: Post cerclage insertion',
    // Post Delivery Complications
    'Discharge: Post PPH with transfusion',
    'Discharge: Post eclampsia',
    'Discharge: Post HELLP syndrome',
    'Discharge: Post cesarean hysterectomy',
    'Discharge: Post severe preeclampsia',
    // Medical Discharges
    'Discharge: After hyperemesis admission',
    'Discharge: After threatened preterm labor',
    'Discharge: After PPROM management',
    'Discharge: After GDM stabilization',
    'Discharge: After PIH monitoring',
    'Discharge: Post miscarriage',
    'Discharge: Post molar pregnancy',
    // Baby Related
    'Discharge: Mother-baby discharge normal',
    'Discharge: Baby to NICU - mother discharge',
    'Discharge: Still birth - mother discharge',
  ],

  // ==========================================
  // CLINICAL CALCULATORS (30+ templates)
  // ==========================================
  calculators: [
    'Calculator: EDD from LMP calculation',
    'Calculator: Gestational age from dates',
    'Calculator: Bishop score assessment',
    'Calculator: Modified Bishop score',
    'Calculator: APGAR score interpretation',
    'Calculator: Fetal weight estimation EFW',
    'Calculator: BMI calculation and category',
    'Calculator: Pregnancy weight gain target',
    'Calculator: GDM risk score',
    'Calculator: Preeclampsia risk calculator',
    'Calculator: VBAC success predictor',
    'Calculator: Ovulation date predictor',
    'Calculator: Fertility window calculation',
    'Calculator: AMH interpretation by age',
    'Calculator: AFC ovarian reserve',
    'Calculator: IVF success probability',
    'Calculator: Fibroid volume calculation',
    'Calculator: Ovarian cyst volume',
    'Calculator: Creatinine clearance pregnancy',
    'Calculator: Anemia classification WHO',
    'Calculator: Blood loss estimation',
    'Calculator: Fluid requirement calculation',
    'Calculator: Drug dosing in pregnancy',
    'Calculator: Anticoagulation dosing',
    'Calculator: GFR in pregnancy',
  ],

  // ==========================================
  // INVESTIGATIONS (50+ templates)
  // ==========================================
  investigations: [
    // Blood Tests
    'Investigation: First trimester screening',
    'Investigation: Quadruple marker interpretation',
    'Investigation: NIPT result explanation',
    'Investigation: PCOS hormonal profile',
    'Investigation: Day 2/3 hormones infertility',
    'Investigation: Day 21 progesterone',
    'Investigation: AMH and AFC interpretation',
    'Investigation: Thyroid function pregnancy',
    'Investigation: Iron studies anemia',
    'Investigation: Coagulation profile pre-op',
    'Investigation: Tumor markers CA-125',
    'Investigation: Beta hCG interpretation',
    'Investigation: Glucose tolerance test 75g',
    'Investigation: Rubella immunity check',
    'Investigation: TORCH profile interpretation',
    'Investigation: Hepatitis B screening',
    'Investigation: HIV screening protocol',
    'Investigation: Syphilis screening',
    'Investigation: Blood group and Rh typing',
    'Investigation: Indirect Coombs test',
    // Imaging
    'Investigation: First trimester ultrasound',
    'Investigation: NT scan interpretation',
    'Investigation: Anomaly scan checklist',
    'Investigation: Growth scan interpretation',
    'Investigation: Doppler in high risk pregnancy',
    'Investigation: Biophysical profile scoring',
    'Investigation: Pelvic ultrasound technique',
    'Investigation: TVS vs TAS indications',
    'Investigation: Follicular tracking protocol',
    'Investigation: HSG interpretation',
    'Investigation: MRI pelvis indications',
    'Investigation: CT in gynec malignancy',
    // Procedures
    'Investigation: Amniocentesis indications',
    'Investigation: CVS vs amniocentesis',
    'Investigation: Endometrial biopsy',
    'Investigation: Cervical biopsy interpretation',
    'Investigation: Colposcopy findings',
    'Investigation: Pap smear technique',
    'Investigation: Semen analysis WHO criteria',
    'Investigation: Post-coital test',
  ],

  // ==========================================
  // PRESCRIPTIONS (50+ templates)
  // ==========================================
  prescriptions: [
    // Pregnancy
    'Prescription: First trimester supplements',
    'Prescription: Iron and calcium pregnancy',
    'Prescription: Folic acid pre-conception',
    'Prescription: Nausea medication pregnancy',
    'Prescription: Heartburn treatment pregnancy',
    'Prescription: Constipation safe laxatives',
    'Prescription: UTI antibiotics pregnancy',
    'Prescription: Vaginal discharge pregnancy',
    'Prescription: Threatened abortion protocol',
    'Prescription: Preterm labor tocolysis',
    'Prescription: GDM - metformin protocol',
    'Prescription: PIH - antihypertensives',
    'Prescription: Severe preeclampsia MgSO4',
    'Prescription: Antenatal steroids protocol',
    'Prescription: Rh prophylaxis anti-D',
    // Gynecology
    'Prescription: PCOS - OCP regimen',
    'Prescription: PCOS - Metformin protocol',
    'Prescription: Endometriosis pain management',
    'Prescription: Fibroid - medical management',
    'Prescription: HMB - tranexamic acid',
    'Prescription: HMB - hormonal treatment',
    'Prescription: Vaginal candidiasis',
    'Prescription: Bacterial vaginosis',
    'Prescription: Trichomonas treatment',
    'Prescription: PID antibiotic protocol',
    'Prescription: Genital herpes management',
    'Prescription: HPV warts treatment',
    'Prescription: Menopause HRT regimen',
    'Prescription: Vaginal estrogen local',
    'Prescription: Osteoporosis prevention',
    // Infertility
    'Prescription: Letrozole ovulation induction',
    'Prescription: Clomiphene citrate protocol',
    'Prescription: Gonadotropin injection protocol',
    'Prescription: Progesterone support IVF',
    'Prescription: Estrogen priming protocol',
    // Post-operative
    'Prescription: Post cesarean pain',
    'Prescription: Post hysterectomy',
    'Prescription: Post laparoscopy',
    'Prescription: Wound care medications',
    'Prescription: DVT prophylaxis post surgery',
    'Prescription: Lactation suppression',
  ],

  // ==========================================
  // PATIENT EDUCATION (60+ templates)
  // ==========================================
  patientEducation: [
    // Pregnancy
    'Patient Education: First trimester do and dont',
    'Patient Education: Warning signs in pregnancy',
    'Patient Education: Kick count monitoring',
    'Patient Education: Labor signs recognition',
    'Patient Education: When to go to hospital',
    'Patient Education: Breastfeeding basics',
    'Patient Education: Post-partum care',
    'Patient Education: Post cesarean recovery',
    'Patient Education: Contraception after delivery',
    'Patient Education: Baby care basics',
    // Conditions
    'Patient Education: PCOS lifestyle guide',
    'Patient Education: Endometriosis explained',
    'Patient Education: Fibroids - what to know',
    'Patient Education: Ovarian cysts information',
    'Patient Education: Menopause transition',
    'Patient Education: HRT benefits and risks',
    'Patient Education: Cervical cancer prevention',
    'Patient Education: HPV vaccination info',
    'Patient Education: Breast self-examination',
    'Patient Education: Pelvic floor exercises',
    // Procedures
    'Patient Education: Preparing for surgery',
    'Patient Education: Day of surgery guide',
    'Patient Education: After hysterectomy care',
    'Patient Education: After laparoscopy care',
    'Patient Education: IVF process step by step',
    'Patient Education: IUI what to expect',
    'Patient Education: Egg freezing process',
    'Patient Education: HSG procedure preparation',
    // Lifestyle
    'Patient Education: Diet for fertility',
    'Patient Education: Exercise guidelines pregnancy',
    'Patient Education: Weight management PCOS',
    'Patient Education: Smoking and fertility',
    'Patient Education: Alcohol in pregnancy',
    'Patient Education: Caffeine limits pregnancy',
    'Patient Education: Travel during pregnancy',
    'Patient Education: Work during pregnancy',
  ],

  // ==========================================
  // MEDICO-LEGAL (40+ templates)
  // ==========================================
  medicoLegal: [
    // Documentation
    'Medico-legal: Complete case documentation',
    'Medico-legal: Operative notes format',
    'Medico-legal: Complication documentation',
    'Medico-legal: Incident report format',
    'Medico-legal: Against medical advice form',
    'Medico-legal: Refusal of treatment form',
    'Medico-legal: Death summary format',
    'Medico-legal: Maternal death review',
    'Medico-legal: Near-miss documentation',
    // Certificates
    'Medico-legal: Birth certificate format',
    'Medico-legal: Stillbirth certificate',
    'Medico-legal: Medical fitness certificate',
    'Medico-legal: Disability certificate gynec',
    'Medico-legal: Maternity leave certificate',
    'Medico-legal: Death certificate format',
    // Legal Aspects
    'Medico-legal: MTP Act provisions',
    'Medico-legal: PCPNDT Act compliance',
    'Medico-legal: Surrogacy Act requirements',
    'Medico-legal: ART regulations compliance',
    'Medico-legal: Consumer protection act',
    'Medico-legal: Negligence vs complication',
    'Medico-legal: Informed consent elements',
    'Medico-legal: Documentation standards NABH',
    // Reporting
    'Medico-legal: PCPNDT Form F',
    'Medico-legal: MTP register maintenance',
    'Medico-legal: Sexual assault examination',
    'Medico-legal: Age estimation female',
    'Medico-legal: Virginity examination ethics',
    'Medico-legal: Domestic violence documentation',
  ],

  // ==========================================
  // PRACTICE MANAGEMENT (50+ templates)
  // ==========================================
  practice: [
    // SOPs
    'Practice: OPD patient flow SOP',
    'Practice: Emergency protocol SOP',
    'Practice: Infection control SOP',
    'Practice: Biomedical waste management',
    'Practice: Sterilization protocol',
    'Practice: Operation theater protocol',
    'Practice: Labor room protocol',
    'Practice: NICU admission protocol',
    'Practice: Blood bank requisition SOP',
    'Practice: Patient consent SOP',
    'Practice: Medical records management',
    'Practice: Medication administration SOP',
    // Staff Training
    'Practice: Nursing staff orientation',
    'Practice: Emergency drill protocol',
    'Practice: Hand hygiene training',
    'Practice: Fire safety training',
    'Practice: BLS training requirements',
    'Practice: Communication skills training',
    // Quality
    'Practice: Clinical audit template',
    'Practice: Mortality meeting format',
    'Practice: Morbidity review process',
    'Practice: Patient feedback analysis',
    'Practice: Complaints handling SOP',
    'Practice: Quality indicators OBGYN',
    // Growth
    'Practice: Clinic branding strategy',
    'Practice: Online presence building',
    'Practice: Google reviews strategy',
    'Practice: Patient retention techniques',
    'Practice: New service introduction',
    'Practice: Referral network building',
    'Practice: Insurance empanelment process',
    'Practice: Corporate tie-ups health check',
  ],

  // ==========================================
  // SOCIAL MEDIA & CONTENT (40+ templates)
  // ==========================================
  socialMedia: [
    // Posts
    'Social Media: PCOS awareness post',
    'Social Media: Endometriosis awareness',
    'Social Media: Breast cancer awareness',
    'Social Media: Cervical cancer prevention',
    'Social Media: HPV vaccination campaign',
    'Social Media: Pregnancy tips series',
    'Social Media: Fertility awareness post',
    'Social Media: Menopause myths busted',
    'Social Media: Contraception options info',
    'Social Media: Womens day special post',
    // Reels/Videos
    'Social Media: PCOS symptoms reel script',
    'Social Media: 5 pregnancy myths video',
    'Social Media: Signs of labor video',
    'Social Media: IVF process explained reel',
    'Social Media: Laparoscopy benefits video',
    'Social Media: Doctor introduction reel',
    'Social Media: Clinic tour video script',
    // Carousels
    'Social Media: PCOS diet tips carousel',
    'Social Media: Pregnancy week by week',
    'Social Media: Warning signs carousel',
    'Social Media: Menstrual health carousel',
    'Social Media: Fertility facts carousel',
    // Blogs/Articles
    'Social Media: SEO article PCOS',
    'Social Media: Blog post endometriosis',
    'Social Media: Article on IVF success',
    'Social Media: Menopause guide article',
    'Social Media: Pregnancy nutrition blog',
  ],

  // ==========================================
  // PRESENTATIONS (30+ templates)
  // ==========================================
  presentations: [
    'Presentation: PCOS management CME',
    'Presentation: High risk pregnancy',
    'Presentation: Laparoscopy in gynecology',
    'Presentation: Infertility workup for GPs',
    'Presentation: Cervical cancer screening',
    'Presentation: Menopause HRT update',
    'Presentation: Endometriosis management',
    'Presentation: AUB approach',
    'Presentation: Ovarian cancer update',
    'Presentation: Ectopic pregnancy management',
    'Presentation: VBAC counseling',
    'Presentation: GDM management',
    'Presentation: Preeclampsia update',
    'Presentation: PPH prevention protocol',
    'Presentation: Hysteroscopy basics',
    'Presentation: Robotic surgery in OBGYN',
    'Presentation: Fetal medicine basics',
    'Presentation: Adolescent gynecology',
    'Presentation: Contraception counseling',
    'Presentation: STI management',
    'Presentation: Pelvic floor disorders',
    'Presentation: Quality improvement OBGYN',
  ],

  // ==========================================
  // GUIDELINES (40+ templates)
  // ==========================================
  guidelines: [
    'Guidelines: ACOG cervical screening 2024',
    'Guidelines: RCOG ectopic pregnancy',
    'Guidelines: FOGSI PCOS management',
    'Guidelines: WHO antenatal care',
    'Guidelines: ESHRE endometriosis',
    'Guidelines: FIGO staging gynec cancers',
    'Guidelines: NICE heavy menstrual bleeding',
    'Guidelines: ISUOG fetal assessment',
    'Guidelines: ACOG GDM screening',
    'Guidelines: SMFM preeclampsia prevention',
    'Guidelines: ASRM infertility workup',
    'Guidelines: ESHRE poor ovarian response',
    'Guidelines: WHO PPH management',
    'Guidelines: RCOG preterm labor',
    'Guidelines: ACOG VBAC selection',
    'Guidelines: SOGC multiple pregnancy',
    'Guidelines: RANZCOG induction of labor',
    'Guidelines: AIUM obstetric ultrasound',
    'Guidelines: ACR imaging in pregnancy',
    'Guidelines: CDC STI treatment',
    'Guidelines: NAMS menopause HRT',
    'Guidelines: ISGE hysteroscopy',
  ],

  // ==========================================
  // ICD CODING (30+ templates)
  // ==========================================
  icdCoding: [
    'ICD Coding: PCOS diagnosis codes',
    'ICD Coding: Endometriosis staging codes',
    'ICD Coding: Fibroid uterus codes',
    'ICD Coding: Ovarian cyst codes',
    'ICD Coding: Infertility codes',
    'ICD Coding: Pregnancy complications',
    'ICD Coding: Cesarean section codes',
    'ICD Coding: Hysterectomy procedure codes',
    'ICD Coding: Laparoscopy codes',
    'ICD Coding: Hysteroscopy codes',
    'ICD Coding: Ectopic pregnancy',
    'ICD Coding: Miscarriage codes',
    'ICD Coding: Preterm labor codes',
    'ICD Coding: GDM codes',
    'ICD Coding: Preeclampsia codes',
    'ICD Coding: PPH codes',
    'ICD Coding: Cervical dysplasia',
    'ICD Coding: Gynecologic malignancy',
    'ICD Coding: Menopause codes',
    'ICD Coding: Contraception procedure codes',
  ],

  // ==========================================
  // DIET & NUTRITION (30+ templates)
  // ==========================================
  diet: [
    'Diet: PCOS low glycemic index plan',
    'Diet: Pregnancy trimester wise nutrition',
    'Diet: Iron rich diet for anemia',
    'Diet: Calcium rich diet pregnancy',
    'Diet: GDM carb counting diet',
    'Diet: Endometriosis anti-inflammatory',
    'Diet: Menopause bone health diet',
    'Diet: Fertility boosting foods',
    'Diet: Post-operative recovery diet',
    'Diet: Breastfeeding nutrition guide',
    'Diet: Weight loss PCOS friendly',
    'Diet: Vegetarian pregnancy diet',
    'Diet: Vegan pregnancy considerations',
    'Diet: Foods to avoid in pregnancy',
    'Diet: Hyperemesis diet tips',
    'Diet: Constipation prevention diet',
    'Diet: Pre-IVF diet optimization',
    'Diet: Mediterranean diet fertility',
    'Diet: Low FODMAP for endometriosis',
    'Diet: Intermittent fasting PCOS',
  ],

  // ==========================================
  // DRUG INFORMATION (40+ templates)
  // ==========================================
  drugs: [
    'Drug Info: Metformin in PCOS',
    'Drug Info: Letrozole vs Clomiphene',
    'Drug Info: Progesterone formulations',
    'Drug Info: GnRH agonists uses',
    'Drug Info: GnRH antagonists IVF',
    'Drug Info: Gonadotropins types',
    'Drug Info: Oxytocin protocols',
    'Drug Info: Misoprostol uses OBGYN',
    'Drug Info: Magnesium sulfate protocol',
    'Drug Info: Labetalol in PIH',
    'Drug Info: Nifedipine in pregnancy',
    'Drug Info: Betamethasone protocol',
    'Drug Info: Dexamethasone in pregnancy',
    'Drug Info: Tranexamic acid AUB',
    'Drug Info: Mefenamic acid dysmenorrhea',
    'Drug Info: Combined oral contraceptives',
    'Drug Info: Progestin only pills',
    'Drug Info: Levonorgestrel IUD',
    'Drug Info: Etonogestrel implant',
    'Drug Info: Ulipristal for fibroids',
    'Drug Info: Dienogest endometriosis',
    'Drug Info: HRT formulations',
    'Drug Info: Bisphosphonates osteoporosis',
    'Drug Info: Antibiotics safe in pregnancy',
    'Drug Info: Analgesics by trimester',
    'Drug Info: Antiemetics pregnancy safe',
    'Drug Info: Antihypertensives pregnancy',
    'Drug Info: Anticoagulants pregnancy',
    'Drug Info: Antiepileptics teratogenicity',
    'Drug Info: Psychiatric drugs pregnancy',
  ],

  // ==========================================
  // ULTRASOUND REPORTING (30+ templates)
  // ==========================================
  ultrasound: [
    'Ultrasound Report: Early pregnancy viability',
    'Ultrasound Report: Dating scan first trimester',
    'Ultrasound Report: NT scan template',
    'Ultrasound Report: 18-20 week anomaly scan',
    'Ultrasound Report: Growth scan third trimester',
    'Ultrasound Report: Biophysical profile',
    'Ultrasound Report: Doppler assessment',
    'Ultrasound Report: Cervical length measurement',
    'Ultrasound Report: Placental localization',
    'Ultrasound Report: Amniotic fluid assessment',
    'Ultrasound Report: Multiple pregnancy scan',
    'Ultrasound Report: Pelvic ultrasound gynec',
    'Ultrasound Report: Ovarian cyst characterization',
    'Ultrasound Report: Fibroid mapping',
    'Ultrasound Report: Adenomyosis features',
    'Ultrasound Report: Endometrial assessment',
    'Ultrasound Report: PCOS criteria ultrasound',
    'Ultrasound Report: Follicular study',
    'Ultrasound Report: Post-menopausal bleeding scan',
    'Ultrasound Report: Ectopic pregnancy features',
    'Ultrasound Report: Molar pregnancy features',
    'Ultrasound Report: Ovarian mass - IOTA',
  ],

  // ==========================================
  // RESEARCH & ACADEMICS (30+ templates)
  // ==========================================
  research: [
    'Research: Case report structure',
    'Research: Case series methodology',
    'Research: Observational study design',
    'Research: Cohort study protocol',
    'Research: Case-control study design',
    'Research: RCT protocol template',
    'Research: Systematic review method',
    'Research: Meta-analysis approach',
    'Research: Quality improvement project',
    'Research: Clinical audit methodology',
    'Research: Abstract for conference',
    'Research: Poster presentation format',
    'Research: Oral presentation structure',
    'Research: Paper writing structure IMRaD',
    'Research: Statistical methods OBGYN',
    'Research: Sample size calculation',
    'Research: Ethical approval application',
    'Research: Informed consent research',
    'Research: Literature search strategy',
    'Research: Reference management',
  ],

  // ==========================================
  // MISCELLANEOUS (30+ templates)
  // ==========================================
  miscellaneous: [
    'Misc: Interview preparation OBGYN',
    'Misc: Board exam preparation tips',
    'Misc: Fellowship application guide',
    'Misc: CV format for doctors',
    'Misc: Cover letter for jobs',
    'Misc: Conference presentation tips',
    'Misc: Journal selection for publication',
    'Misc: Peer review guidelines',
    'Misc: Teaching methodology tips',
    'Misc: Student assessment methods',
    'Misc: Communication with nurses',
    'Misc: Interdisciplinary team communication',
    'Misc: Handling difficult patients',
    'Misc: Managing patient expectations',
    'Misc: Time management clinic',
    'Misc: Burnout prevention doctors',
    'Misc: Work-life balance medicine',
    'Misc: Dealing with adverse outcomes',
    'Misc: Learning from complications',
    'Misc: Continuous medical education',
  ],

  // ==========================================
  // ADDITIONAL CLINICAL SCENARIOS (100+ templates)
  // ==========================================
  additionalClinical: [
    // Advanced Obstetric Scenarios
    'Clinical: Multiple pregnancy with discordant growth',
    'Clinical: Vasa previa management protocol',
    'Clinical: Cervical length monitoring in twins',
    'Clinical: Monochorionic diamniotic complications',
    'Clinical: Selective IUGR in twins management',
    'Clinical: Twin to twin transfusion syndrome',
    'Clinical: Twin anemia polycythemia sequence',
    'Clinical: Monoamniotic twins delivery planning',
    'Clinical: Higher order multiples reduction',
    'Clinical: Conjoined twins diagnosis',
    // Fetal Medicine
    'Clinical: Fetal hydrops non-immune workup',
    'Clinical: Fetal anemia diagnosis and treatment',
    'Clinical: Intrauterine transfusion procedure',
    'Clinical: Fetal cardiac anomaly counseling',
    'Clinical: Neural tube defect counseling',
    'Clinical: Chromosomal abnormality options',
    'Clinical: Fetal skeletal dysplasia workup',
    'Clinical: Diaphragmatic hernia prognosis',
    'Clinical: Posterior urethral valves management',
    'Clinical: Fetal abdominal wall defects',
    // Maternal Medicine
    'Clinical: Cardiac surgery in pregnancy',
    'Clinical: Valvular heart disease labor management',
    'Clinical: Pulmonary hypertension in pregnancy',
    'Clinical: Marfan syndrome pregnancy monitoring',
    'Clinical: Ehlers-Danlos in pregnancy',
    'Clinical: Pregnancy after heart transplant',
    'Clinical: Pregnancy after kidney transplant',
    'Clinical: Liver transplant and pregnancy',
    'Clinical: Systemic sclerosis in pregnancy',
    'Clinical: Myasthenia gravis pregnancy',
    // Reproductive Endocrinology
    'Clinical: Hypothalamic amenorrhea workup',
    'Clinical: Functional hypothalamic amenorrhea',
    'Clinical: Pituitary tumor and fertility',
    'Clinical: Sheehan syndrome diagnosis',
    'Clinical: Cushing syndrome in pregnancy',
    'Clinical: Adrenal insufficiency pregnancy',
    'Clinical: CAH and pregnancy',
    'Clinical: Turner syndrome fertility',
    'Clinical: Swyer syndrome management',
    'Clinical: Androgen insensitivity syndrome',
    // Gynecologic Oncology
    'Clinical: Cervical cancer in pregnancy',
    'Clinical: Ovarian cancer staging surgery',
    'Clinical: Endometrial cancer treatment',
    'Clinical: Vulvar cancer management',
    'Clinical: Vaginal cancer treatment',
    'Clinical: Gestational trophoblastic disease',
    'Clinical: Choriocarcinoma chemotherapy',
    'Clinical: Invasive mole management',
    'Clinical: Placental site trophoblastic tumor',
    'Clinical: Epithelioid trophoblastic tumor',
    // Urogynecology
    'Clinical: Mixed urinary incontinence',
    'Clinical: Urge incontinence management',
    'Clinical: Pelvic organ prolapse POP-Q staging',
    'Clinical: Vault prolapse after hysterectomy',
    'Clinical: Rectocele repair options',
    'Clinical: Enterocele diagnosis',
    'Clinical: Urethral diverticulum',
    'Clinical: Vesicovaginal fistula repair',
    'Clinical: Rectovaginal fistula management',
    'Clinical: Mesh complications after surgery',
    // Pediatric Gynecology
    'Clinical: Labial adhesions management',
    'Clinical: Prepubertal vaginal bleeding',
    'Clinical: Ovarian mass in child',
    'Clinical: Precocious puberty workup',
    'Clinical: Delayed puberty evaluation',
    'Clinical: Ambiguous genitalia workup',
    'Clinical: Disorders of sex development',
    'Clinical: Vaginal agenesis options',
    'Clinical: MRKH syndrome management',
    'Clinical: Gonadal dysgenesis',
    // Sexual Medicine
    'Clinical: Female sexual arousal disorder',
    'Clinical: Hypoactive sexual desire disorder',
    'Clinical: Persistent genital arousal disorder',
    'Clinical: Post-menopausal sexual health',
    'Clinical: Painful intercourse evaluation',
    'Clinical: Sexual pain disorders',
    'Clinical: Genitourinary syndrome of menopause',
    'Clinical: Vaginal laxity treatment options',
    'Clinical: Sexual rehabilitation after cancer',
    'Clinical: LGBTQ healthcare considerations',
    // Infections
    'Clinical: HIV positive pregnancy management',
    'Clinical: Hepatitis B in pregnancy',
    'Clinical: Hepatitis C pregnancy care',
    'Clinical: CMV infection in pregnancy',
    'Clinical: Toxoplasmosis pregnancy screening',
    'Clinical: Parvovirus B19 infection',
    'Clinical: Varicella zoster in pregnancy',
    'Clinical: Zika virus pregnancy concerns',
    'Clinical: COVID-19 in pregnancy',
    'Clinical: Tuberculosis in pregnancy',
    // Substance Use
    'Clinical: Opioid use disorder in pregnancy',
    'Clinical: Neonatal abstinence syndrome',
    'Clinical: Marijuana use in pregnancy',
    'Clinical: Cocaine use pregnancy effects',
    'Clinical: Methamphetamine exposure fetus',
    'Clinical: Alcohol use disorder pregnancy',
    'Clinical: Fetal alcohol spectrum disorders',
    'Clinical: Tobacco cessation in pregnancy',
    'Clinical: Vaping during pregnancy',
    'Clinical: Medication assisted treatment pregnancy',
  ],

  // ==========================================
  // SPECIFIC PROCEDURE TEMPLATES (50+ templates)
  // ==========================================
  procedures: [
    'Procedure: Amniocentesis step by step',
    'Procedure: Chorionic villus sampling technique',
    'Procedure: Cordocentesis indications',
    'Procedure: External cephalic version protocol',
    'Procedure: Cervical cerclage insertion',
    'Procedure: Cervical cerclage removal',
    'Procedure: Bartholin gland marsupialization',
    'Procedure: Endometrial biopsy technique',
    'Procedure: Colposcopy procedure',
    'Procedure: LEEP excision technique',
    'Procedure: Cone biopsy cold knife',
    'Procedure: D&C technique',
    'Procedure: Manual vacuum aspiration',
    'Procedure: Medical abortion protocol',
    'Procedure: Surgical abortion technique',
    'Procedure: IUD insertion procedure',
    'Procedure: IUD removal technique',
    'Procedure: Nexplanon insertion',
    'Procedure: Nexplanon removal',
    'Procedure: Tubal ligation techniques',
    'Procedure: Essure placement',
    'Procedure: Hysterosalpingography technique',
    'Procedure: Sonohysterography procedure',
    'Procedure: Saline infusion sonography',
    'Procedure: Urodynamic testing protocol',
    'Procedure: Cystoscopy in gynecology',
    'Procedure: Vulvar biopsy technique',
    'Procedure: Vaginal pessary fitting',
    'Procedure: Pelvic floor assessment',
    'Procedure: Episiotomy repair',
    'Procedure: Perineal tear repair',
    'Procedure: Cervical laceration repair',
    'Procedure: Vaginal laceration repair',
    'Procedure: Pudendal nerve block',
    'Procedure: Paracervical block',
    'Procedure: Epidural placement technique',
    'Procedure: Spinal anesthesia technique',
    'Procedure: Intrauterine balloon tamponade',
    'Procedure: B-Lynch suture technique',
    'Procedure: Uterine artery ligation',
    'Procedure: Internal iliac artery ligation',
    'Procedure: Peripartum hysterectomy',
    'Procedure: Manual removal of placenta',
    'Procedure: Vacuum extraction technique',
    'Procedure: Forceps delivery technique',
    'Procedure: Breech extraction',
    'Procedure: Internal podalic version',
    'Procedure: Cesarean section technique',
    'Procedure: Classical cesarean indications',
    'Procedure: Exit procedure technique',
  ],

  // ==========================================
  // IMAGING INTERPRETATION (30+ templates)
  // ==========================================
  imaging: [
    'Imaging: First trimester ultrasound interpretation',
    'Imaging: Second trimester anomaly scan checklist',
    'Imaging: Third trimester growth assessment',
    'Imaging: Fetal Doppler interpretation',
    'Imaging: BPP scoring interpretation',
    'Imaging: Cervical length measurement',
    'Imaging: Placental localization',
    'Imaging: Umbilical cord assessment',
    'Imaging: Amniotic fluid index calculation',
    'Imaging: Pelvic MRI for endometriosis',
    'Imaging: MRI for fibroid mapping',
    'Imaging: CT scan for ovarian mass',
    'Imaging: PET scan for gynec cancer',
    'Imaging: Mammography interpretation',
    'Imaging: Breast ultrasound BI-RADS',
    'Imaging: Breast MRI indications',
    'Imaging: HSG findings interpretation',
    'Imaging: SIS findings evaluation',
    'Imaging: 3D ultrasound uterine anomaly',
    'Imaging: IOTA rules for ovarian mass',
    'Imaging: Adnexal mass O-RADS scoring',
    'Imaging: Endometrial assessment ultrasound',
    'Imaging: Fibroid FIGO classification',
    'Imaging: Ovarian cyst ultrasound features',
    'Imaging: Ectopic pregnancy ultrasound',
    'Imaging: Molar pregnancy imaging',
    'Imaging: Fetal cardiac imaging',
    'Imaging: Fetal brain MRI indications',
    'Imaging: Postpartum imaging evaluation',
    'Imaging: Bladder ultrasound assessment',
  ],
};

// Flatten all templates into a single array
export const FLAT_TEMPLATES = Object.values(ALL_TEMPLATES).flat();

// Get templates by category
export const getTemplatesByCategory = (category) => {
  return ALL_TEMPLATES[category] || [];
};

// Get all category names
export const TEMPLATE_CATEGORIES = Object.keys(ALL_TEMPLATES);

// Search templates
export const searchTemplates = (query) => {
  const lowerQuery = query.toLowerCase();
  return FLAT_TEMPLATES.filter(template => 
    template.toLowerCase().includes(lowerQuery)
  );
};

// Get template count
export const TEMPLATE_COUNT = FLAT_TEMPLATES.length;

export default ALL_TEMPLATES;
